module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Enviar Novo Email Lote' + this.parent.formData.lote,
      "modal": _vm.showFormRegister,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "60%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'Emails Lote ' + this.parent.formData.lote,
      "modal": _vm.showFormList,
      "width": "98%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('LogEmail', {
    attrs: {
      "point_type": "esocial-lote",
      "point_id": _vm.parent.formData.id,
      "onRegister": _vm.onRegister
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0568b513"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/lotes/email/index.vue
// module id = 1354
// module chunks = 45